import axios, { Canceler, CancelTokenStatic } from 'axios';

import { IAbsenceBalanceDTO, IEmployeeBalanceDTO, IFutureBalanceRequestDTO } from 'src/api/dtos';
import http from 'src/api/http';
import ESSRepository from 'src/api/repositories/ess/ess.repository';
import { IListQueryResult, IQueryResult } from 'src/api/types';
import { getAxiosParams } from 'src/shared/utils';

const CancelToken: CancelTokenStatic = axios.CancelToken;

export default class BalanceRepository extends ESSRepository {
  private static readonly baseRoute = '/balances';
  private static readonly apiURL = BalanceRepository.setBaseUrl(this.baseURL, this.baseRoute);

  public get = async (): Promise<IAbsenceBalanceDTO[]> => {
    try {
      const { data } = await http.get<IListQueryResult<IAbsenceBalanceDTO>>(BalanceRepository.apiURL);
      return data.items;
    } catch (e) {
      return Promise.reject(e);
    }
  };

  public getFutureBalance = async (
    params: IFutureBalanceRequestDTO,
    onCancel?: (c: Canceler) => void,
  ): Promise<IEmployeeBalanceDTO> => {
    try {
      const cancelRequest = (c: Canceler) => {
        if (!onCancel) {
          return;
        }

        onCancel(c);
      };

      const { data } = await http.get<IQueryResult<IEmployeeBalanceDTO>>(`${BalanceRepository.apiURL}/futureBalance`, {
        cancelToken: new CancelToken(cancelRequest),
        ...getAxiosParams(params),
      });

      return data.item;
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
